import React from 'react';
import Skills from '../components/Skills';

function Experience() {
  return (
    <div className="skills-resume">
      <Skills />
    </div>
  );
}

export default Experience;
